// extracted by mini-css-extract-plugin
module.exports = {"lia-chapter":"ChapterItem_lia-chapter__GTgQ6"};